// extracted by mini-css-extract-plugin
export default {"doughnut_chart":"Home_doughnut_chart__F9N8T","chart":"Home_chart__i7KJB","card":"Home_card__SRZZ1","charts":"Home_charts__VRp3s"};